@if (currentUser()) {
  <div class="flex flex-col overflow-y-auto ios-scroll">
    @if (type() === StatusMessageType.Error && message()) {
      <div
        class="fixed top-[calc(102px+env(safe-area-inset-top))] desktop:top-[calc(150px+env(safe-area-inset-top))] left-0 right-0 z-50 size-fit mx-auto transition duration-300 ease-out opacity-0"
        [class.opacity-100]="message()"
        [class.translate-y-0]="message()"
      >
        <sc-status-message-widget [type]="type()" [subtitle]="message()"></sc-status-message-widget>
      </div>
    }
    <div
      class="bg-secondaryRed"
      [class.desktop:pt-[156px]]="!isMobileMode() && !isPortingBlocked()"
      [class.pt-[env(safe-area-inset-top)]]="isMobileMode()"
      [class.pb-16]="shouldShowSticky()"
    >
      @if (!isMobileMode()) {
        <sc-mobile-header
          [hideNav]="isSelectProductPage()"
          class="desktop:hidden"
        ></sc-mobile-header>
        <sc-desktop-header
          [hideNav]="isSelectProductPage()"
          class="hidden desktop:inline"
        ></sc-desktop-header>
      }

      <div
        class="container desktop:mt-0 pt-8 tablet:pt-tabletGap desktop:pt-desktopGap desktop:grid desktop:grid-cols-[282px_auto] desktop:gap-6"
        [ngClass]="{
          'mb-[140px] tablet:mb-[180px]': !isMobileMode(),
          'mt-[102px]': !isMobileMode() && !isPortingBlocked(),
        }"
      >
        <sc-sidebar
          class="hidden desktop:block sticky top-44 w-[282px]"
          *ngIf="!isFullWidthPage()"
        ></sc-sidebar>

        <main *ngIf="currentUser()" [ngClass]="{ 'desktop:col-span-2': isFullWidthPage() }">
          <router-outlet></router-outlet>
        </main>
      </div>
      @if (!isMobileMode()) {
        <sc-footer [isMyEnvironment]="true"></sc-footer>
      }
    </div>
  </div>
} @else {
  <div class="h-screen w-screen">
    <sc-loader></sc-loader>
  </div>
}
